module.exports = __webpack_public_path__ + "static/media/CAS-Background.fcfb2a33.jpg";